<template>
  <div class="yht-yjztModule">
    <Header theme="brown"></Header>
    <div class="yht-yjztModule-main">
      <div class="yht-yjztModule-content">
        <div class="yht-yjztModule-crumb">
          <span>当前位置：</span><span class="cp yht-yjztModule-crumb_hover" @click="goHome">首页</span>
          >
          <span class="cp yht-yjztModule-crumb_hover" @click="goZtyj" v-text="moduleName"></span>
          >
          <span v-text="moduleCode"></span>
        </div>
        <div class="search">
          <div class="search-box">
            <el-input placeholder="请输入检索词..." v-model="inputValue" class="input-group" maxlength="100" @keyup.enter.native="handleSearch">
              <el-select class="select-group" v-model="selectValue" slot="prepend" placeholder="请选择">
                <el-option v-for="m in options" :key="m.fieldname" :label="m.displayname" :value="m.fieldname">
                </el-option>
              </el-select>
            </el-input>
            <div class="line"></div>
            <div class="search-icon cp" @click="handleSearch"></div>
          </div>
        </div>
        <div class="search-count">
          <span class="count">共找到{{ total }}条结果</span>
          <div class="right-sort">
            <span>排序:</span>
            <span class="sort-title" @click="sortStatusFn">相关度<span class="sort"
                :class="{ 'down': reStatus }"></span></span>
            <span class="sort-title" @click="sortTimeFn">发表时间<span class="sort"
                :class="{ 'down': timeStatus }"></span></span>
          </div>
        </div>
        <div class="yht-yjztModule-center">
          <div class="nav">
            <div class="nav-header">
              <span class="title">文献分类导航</span>
              <div class="title-icon"></div>
            </div>
            <div class="nav-btn">
              <el-button type="text" class="btn" @click="checkedAll">全选</el-button>
              <el-button type="text" class="btn" @click="resetChecked">清除</el-button>
            </div>
            <div class="nav-content">
              <el-tree ref="tree" :data="tree" show-checkbox node-key="id" :check-strictly="false"
                :default-expanded-keys="naviList" :default-checked-keys="naviList" @check-change="handleNodeClick"
                :props="{ children: 'children', label: 'name' }"
                :check-on-click-node="true"
                >
              </el-tree>
            </div>
            <div class="nav-footer"></div>
          </div>
          <div class="yht-yjztModule-center_table">
            <el-table v-loading="loading" class="table-box" ref="table" :header-cell-style="{
              background: '#C0AA90',
              fontsize: '16px',
              color: '#FFFFFF',
              fontWeight: 600,
              lineHeight: '22px',
              borderColor: '#CFC0AE'
            }" :cell-style="{ borderColor: '#CFC0AE' }" stripe tooltip-effect="light" :data="tableData">
              <el-table-column prop="name" label="题名">
                <span slot-scope="scope" class="cp title_task" @click="enterDetail(scope.row)"
                  :title="scope.row.name">{{ scope.row.name }}</span>
              </el-table-column>
              <el-table-column prop="author" label="作者" width="200">
                <span slot-scope="scope" :title="scope.row.author">{{
                    scope.row.author
                }}</span>
              </el-table-column>
              <el-table-column prop="publicationTime" label="发表时间" width="110">
                <span slot-scope="scope" :title="scope.row.publicationTime">{{
                    scope.row.publicationTime
                }}</span>
              </el-table-column>
              <el-table-column prop="download" label="下载" width="60">
                <span class="images-download" @click="downloadFn"></span>
              </el-table-column>
              <template slot="empty">
                <!--                <img src="../../assets/images/img/empty200.png" />-->
                <span class="mt10" style="display: block; font-size: 12px; color: #666666">暂无查询数据</span>
              </template>
            </el-table>
            <!-- 页码 -->
            <div class="yht-yjztModule-center_page">
              <el-pagination v-show="total > pageSize && !loading" background layout="total, prev, pager, next"
                :current-page="pageNo" :page-size="pageSize" :total="total" @current-change="changePage">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
      <Bottom></Bottom>
    </div>
  </div>
</template>

<script>
import Header from "@/components/common/header/index.vue";
import Bottom from "@/components/common/bottom/index.vue";
import axios from "axios";

export default {
  name: 'MoreSearch',
  components: { Header, Bottom },
  data() {
    return {
      reStatus: false, // 相关度 默认desc
      timeStatus: false, // 发表时间 默认desc
      orderField: '',
      orderType: '', // 排序方式 desc asc
      inputValue: "",
      selectValue: "主题",
      options: [],
      tree: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      loading: false,
      // 对应关系
      matchObj: {
        hswh: {
          name: "红色文化研究",
          id: "0051090501",
        },
        yhyl: {
          name: "雨花英烈研究",
          id: "0051090503",
        },
        zhgl: {
          name: "综合管理研究",
          id: "0051090505",
        },
      },
      moduleName: '', // 跳转过来二级导航名字
      // 跳转过来的模块code
      moduleCode: "",
      // 跳转过来的模块名字
      // moduleName: "",
      // moduleid: "",
      naviList: [], // tree
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.selectValue = this.$route.query.fieldName
      this.inputValue = this.$route.query.queryName
      this.getSelectData()
      this.getTreeData().then( val => {
        this.getinfoFn()
      })
    },
    // 不同模块进入检索更多页
    getIntoPage () {
      let id = ''
      this.moduleName = this.$route.query.module
      // 综合管理研究用id查name  雨花英烈和红色文化研究用name查id
      if (this.moduleName === '综合管理研究' || this.moduleName === '专题研究') {
        if (this.$route.query.type) {
          id = this.$route.query.type
          this.moduleCode = this.searchName(this.tree, id)
        } else {
          this.moduleCode = '检索结果'
          id = this.searchID(this.tree, this.moduleName)
        }
      } else {
        if (this.$route.query.type) {
          this.moduleCode = this.$route.query.type
          id = this.searchID(this.tree, this.moduleCode)
        } else {
          this.moduleCode = '检索结果'
          id = this.searchID(this.tree, this.moduleName)
        }
      }
      if (id === '00510905') {
        this.naviList = ['0051090501', '0051090503', '0051090505']
      } else {
        this.naviList.push(id)
      }
    },
    // 获取搜索栏下拉框
    getSelectData () {
      axios.get('/yuhuamenhu/special/getAllQueryCriteria').then(res => {
        if (res.status === 200) {
          this.options = JSON.parse(JSON.stringify(res.data.data))
        }
      }).catch(err => {
        console.log(err);
      })
    },
    // 获取左侧树
    getTreeData() {
      return axios.get("/yuhuamenhu/special/getAllZTType")
        .then((res) => {
          if (res.status === 200) {
            this.tree = JSON.parse(JSON.stringify(res.data))
            this.getIntoPage()
          }
        })
        .catch((err) => {
          console.log(err);
        })
    },
    // 在树上查找子节点 根据name查id
    searchID (nodes, searchKey) {
      for (let _i = 0; _i < nodes.length; _i++) {
        if (nodes[_i].name === searchKey) {
          return nodes[_i].id
        } else {
          if (nodes[_i].children && nodes[_i].children.length > 0) {
            let res = this.searchID(nodes[_i].children, searchKey);
            if (res) {
              return res
            }
          }
        }
      }
      return null
    },
    // 在树上查找子节点 根据id查name
    searchName (nodes, searchKey) {
      for (let _i = 0; _i < nodes.length; _i++) {
        if (nodes[_i].id === searchKey) {
          return nodes[_i].name
        } else {
          if (nodes[_i].children && nodes[_i].children.length > 0) {
            let res = this.searchName(nodes[_i].children, searchKey);
            if (res) {
              return res
            }
          }
        }
      }
      return null
    },
    // 分页查询
    getinfoFn () {
      let query = {
        fieldName: this.selectValue,
        orderField: this.orderField,
        orderType: this.orderType,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        queryName: this.inputValue,
        ywfldm: this.naviList
      };
      this.loading = true
      axios
        .post("/yuhuamenhu/special/getSpecialData", query)
        .then((res) => {
          if (res.status === 200) {
            this.loading = false
            this.total = res.data.data.totalRows
            this.tableData = res.data.data.rows
          } else {
            this.$message.warning(res.data.errorMessage);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    // 点击树形控件
    handleNodeClick () {
      this.handleSearch()
    },
    // 搜索栏 检索
    handleSearch() {
      this.naviList = this.$refs.tree.getCheckedKeys()
      this.pageNo = 1
      this.getinfoFn()
    },
    // 全选
    checkedAll() {
      this.$refs.tree.setCheckedNodes(this.tree)
    },
    // 清空
    resetChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    // 相关度排序
    sortStatusFn() {
      this.reStatus = !this.reStatus
      this.orderField = '相关度'
      this.orderType = this.reStatus ? 'asc' : 'desc'
      this.getinfoFn()
    },
    // 发表时间
    sortTimeFn() {
      this.timeStatus = !this.timeStatus
      this.orderField = '发表时间'
      this.orderType = this.timeStatus ? 'asc' : 'desc'
      this.getinfoFn()
    },
    // 下载
    downloadFn () {
      this.$message.warning('暂无文档')
    },
    // 点击分页
    changePage(val) {
      this.pageNo = val;
      this.getinfoFn();
    },
    // 跳转到详情页面
    enterDetail(param) {
      const yjztDetail = this.$router.resolve({
        path: "/yjztDetail",
        query: {
          name: param.name,
          from: param.from,
        },
      });
      window.open(yjztDetail.href, "_blank");
    },

    // 返回首页
    goHome() {
      this.$router.push("/");
    },

    // 返回上一级
    goZtyj() {
      switch (this.moduleName) {
        case '红色文化研究' :
          this.$router.push('/redCulture')
          break
        case '雨花英烈研究':
          this.$router.push('/rainHero')
          break
        case '综合管理研究':
          this.$router.push('/zhglyj')
          break
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.search {
  margin: 26px 263px 24px;
}

::v-deep .el-input__inner {
  background-color: #fff !important;
}

::v-deep .el-input-group__prepend div.el-select .el-input__inner {
  border-radius: 8px 0 0 8px;
}

// 树的展开与收起
// 禁止旋转
::v-deep .el-tree .el-tree-node__expand-icon.expanded {
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
}

//有子节点 且未展开
::v-deep .el-icon-caret-right:before {
  background: url('./images/add.png') no-repeat 0 0;
  content: "";
  display: block;
  width: 14px;
  height: 14px;
  font-size: 14px;
  background-size: 14px;
}

//有子节点 且已展开
::v-deep .el-tree .el-tree-node__expand-icon.expanded.el-icon-caret-right:before {
  background: url("./images/minus.png") no-repeat 0 0;
  content: '';
  display: block;
  width: 14px;
  height: 14px;
  font-size: 14px;
  background-size: 14px;
}

// 无子节点
::v-deep .el-tree .el-tree-node__expand-icon.is-leaf::before {
  background: none;
  content: '';
  display: block;
  width: 14px;
  height: 14px;
  font-size: 14px;
  background-size: 14px;
}

// 勾选
::v-deep .el-checkbox__inner {
  box-shadow: inset 0px 1px 3px 0px #c4baaf;
  border-radius: 2px;
  border-color: #CFC0AE;
}

::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #c4baaf;
  border-color: #c4baaf;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #c4baaf;
  border-color: #c4baaf;
}

::v-deep .el-button--text {
  color: #8B5913;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
}

// 侧导航
.nav {
  position: relative;
  margin-right: 10px;
  width: 250px;
  height: 531px;
  border: 1px solid rgba(139, 29, 19, 0.19);
  background: #f9f9f9;

  .nav-header {
    display: flex;
    width: 100%;
    height: 48px;
    align-items: center;
    justify-content: space-between;
    background: url("./images/nav-header.png") no-repeat;
    background-size: 100% 100%;

    .title {
      margin-left: 15px;
      font-size: 16px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 22px;
    }

    .title-icon {
      width: 20px;
      height: 18px;
      margin-right: 17px;
      background: url("./images/title-icon.png") no-repeat;
      background-size: 100% 100%;
    }
  }

  .nav-btn {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    height: 45px;

    :nth-child(2) {
      margin-right: 17px;
    }
  }

  .nav-content {
    height: 346px;
    overflow: scroll;
    overflow-x: hidden;
  }

  .nav-footer {
    // position: absolute;
    // left: 0;
    // bottom: 0;
    margin-top: 40px;
    width: 208px;
    height: 50px;
    background: url("./images/yht.png");
    background-size: 100% 100%;
  }
}

.search-count {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 20px;
  padding-left: 260px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  line-height: 20px;
  letter-spacing: 1px;

  span {
    display: inline-block;
  }
  .right-sort {
    display: flex;
    justify-content: space-around;
    width: 235px;
  }

  .sort-title {
    cursor: pointer;

    .sort {
      width: 3px;
      height: 12px;
      margin-left: 3px;
      background: url("./images/sort.png") no-repeat 0 0;
      background-size: 100% 100%;
    }

    .down {
      background: url("./images/sort.png") no-repeat 0 0;
      transform: rotate(180deg);
      background-size: 100% 100%;
    }
  }
}
// table边框
.table-box {
  border: 1px solid #CFC0AE;
}

.images-download {
  display: block;
  width: 24px;
  height: 16px;
  background: url("./images/download.png");
  background-size: 100% 100%;
  cursor: pointer;
}

// /* old */
.yht-yjztModule {
  width: 100%;
  height: 100%;
  background-color: #eee6dc;
}

.yht-yjztModule-main {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: calc(100% - 70px);
  background: url("/images/bg.png") no-repeat;
  background-size: 100% 100%;
  overflow: auto;
}

.yht-yjztModule-content {
  flex: 1;
  position: relative;
  padding-top: 19px;
  margin: 0 auto;
  width: 1200px;
}

.yht-yjztModule-crumb {
  position: relative;
  padding-left: 60px;
  width: 100%;
  height: 38px;
  line-height: 38px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
  border-bottom: 2px solid #d8d8d8;
}

.yht-yjztModule-crumb::before {
  content: "";
  position: absolute;
  top: 8px;
  left: 20px;
  width: 22px;
  height: 20px;
  background: url("./images/home.png");
  background-size: 100% 100%;
}

.yht-yjztModule-crumb .yht-yjztModule-crumb_hover:hover {
  color: #8b1d13;
}

.yht-yjztModule-center {
  position: relative;
  display: flex;
  padding-top: 9px;
  width: 100%;
  height: calc(100% - 187px);
}


.yht-yjztModule-center_table {
  width: calc(100% - 250px);
  height: calc(100% - 71px);
}

.yht-yjztModule-center_table .el-table {
  color: #3d3d3d;
}

.yht-yjztModule-center_table .el-table th.el-table__cell {
  background-color: #b3a493;
}

.yht-yjztModule-center_table .el-table th.el-table__cell>.cell {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
}

.yht-yjztModule-center_table .el-table .cell {
  overflow: hidden;
  word-break: keep-all;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 400;
}

.yht-yjztModule-center_table .el-table__row {
  height: 50px;
  line-height: 50px;
}

.yht-yjztModule-center_table .el-table thead {
  height: 50px;
}

.yht-yjztModule-center_page {
  position: relative;
  width: 100%;
  height: 121px;
}

::v-deep .yht-yjztModule-center_page .el-pagination {
  position: absolute;
  top: 50%;
  left: 45%;
  transform: translate(-50%, -50%);
}
</style>
<style scoped>
@import "../search.css";
</style>
